import { ProviderModel } from "./interfaces";
import types from "./types";

import { request } from "api/actions";
import { AxiosRequestConfig } from "axios";
import { GastroPayModel } from "./forms/GastroPay/GastroPayForm";
import { AlexSushiInvoiceModel } from "./forms/AlexSushiInvoice/AlexSushiInvoiceForm";
import DatatransModel from "./forms/Datatrans/types/DatatransModel";

export const providersCreate = (
    project: string,
    prefix: string,
    provider: string,
    data:
        | ProviderModel
        | AlexSushiInvoiceModel
        | DatatransModel
        | GastroPayModel,
    onResponse?: Function,
) =>
    request(
        types.STORE_REQUEST,
        types.STORE_FAILED,
        types.STORE_SUCCESS,
        "providersCreate",
        {
            url: {
                id: provider,
                prefix,
            },
            data,
        },
        onResponse,
        undefined,
        project,
    );

export const providersUpdate = (
    project: string,
    prefix: string,
    id: number,
    provider: string,
    data:
        | ProviderModel
        | AlexSushiInvoiceModel
        | DatatransModel
        | GastroPayModel,
    onResponse?: Function,
) => {
    return request(
        types.UPDATE_REQUEST,
        types.UPDATE_FAILED,
        types.UPDATE_SUCCESS,
        "providersUpdate",
        { data, url: { id, provider, prefix } },
        onResponse,
        undefined,
        project,
    );
};

export const providersCreateGenerateKey = (
    id: string,
    data: ProviderModel,
    onResponse?: Function,
) =>
    request(
        types.STORE_GENERATE_KEY_REQUEST,
        types.STORE_GENERATE_KEY_FAILED,
        types.STORE_GENERATE_KEY_SUCCESS,
        "providersCreateGenerateKey",
        { data, url: { id } },
        onResponse,
    );

export const providersDelete = (
    project: string,
    prefix: string,
    id: number,
    onResponse?: Function,
) =>
    request(
        types.DESTROY_REQUEST,
        types.DESTROY_FAILED,
        types.DESTROY_SUCCESS,
        "providersDelete",
        {
            url: {
                id,
                prefix,
            },
        },
        onResponse,
        undefined,
        project,
    );

export const providersFetch = (
    project: string,
    prefix: string,
    config?: AxiosRequestConfig,
) =>
    request(
        types.FETCH_REQUEST,
        types.FETCH_FAILED,
        types.FETCH_SUCCESS,
        "providersFetch",
        {
            config,
            url: {
                prefix,
            },
        },
        undefined,
        undefined,
        project,
    );

export const providersDefaults = (
    project: string,
    prefix: string,
    config?: AxiosRequestConfig,
    onResponse?: Function,
    modifyResponse?: Function,
) =>
    request(
        types.FETCH_DEFAULT_REQUEST,
        types.FETCH_DEFAULT_FAILED,
        types.FETCH_DEFAULT_SUCCESS,
        "providersDefaults",
        {
            config,
            url: {
                prefix,
            },
        },
        onResponse,
        modifyResponse,
        project,
    );

export const providersFetchAll = (config?: AxiosRequestConfig) =>
    request(
        types.FETCH_ALL_REQUEST,
        types.FETCH_ALL_FAILED,
        types.FETCH_ALL_SUCCESS,
        "providersFetchAll",
        {
            config,
        },
    );

export const providersGet = (project: string, prefix: string, id: number) =>
    request(
        types.GET_REQUEST,
        types.GET_FAILED,
        types.GET_SUCCESS,
        "providersGet",
        {
            url: {
                id,
                prefix,
            },
        },
        undefined,
        undefined,
        project,
    );

export const providersTableUpdate = (action: string, data: any) => ({
    type: types.TABLE_UPDATE,
    action,
    data,
});

export const providersUpdateGenerateKey = (
    id: number,
    providers: string,
    data: ProviderModel,
    onResponse?: Function,
) => {
    return request(
        types.UPDATE_GENERATE_KEY_REQUEST,
        types.UPDATE_GENERATE_KEY_FAILED,
        types.UPDATE_GENERATE_KEY_SUCCESS,
        "providersUpdateGenerateKey",
        { data, url: { id, prevId: providers } },
        onResponse,
    );
};
